import script from "./VideoScriptLibrary.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoScriptLibrary.vue?vue&type=script&setup=true&lang=js"

import "./VideoScriptLibrary.vue?vue&type=style&index=0&id=741b2615&scoped=true&lang=css"
import "./video-script-library-cards.css?vue&type=style&index=1&id=741b2615&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-741b2615"]])

export default __exports__